import { createAnalyticsManager } from './analytics-manager';
import { NullAnalyticsService } from './null-analytics-service';
import { createPostHogAnalyticsService } from './posthog-analytics-service';
import type { AnalyticsManager, AnalyticsProviderFactory } from './types';

export type { AnalyticsService } from './types';

const hasPostHogKey =
  typeof window !== 'undefined' && !!process.env.NEXT_PUBLIC_POSTHOG_KEY;

const providers: Record<
  string,
  AnalyticsProviderFactory<object>
> = hasPostHogKey
  ? { posthog: () => createPostHogAnalyticsService() }
  : { null: () => NullAnalyticsService };

export const analytics: AnalyticsManager = createAnalyticsManager({
  providers,
});
